import { StatsPanel } from './StatsPanel';

export default StatsPanel;
